import React from 'react';

import { bemCssModules, trimStringMiddle } from '@cryptoboyio/mercuryo-lab/utils';

import { getTestId } from '@utils';

import style from '../Transactions.scss';

const cn = bemCssModules(style, 'Transactions');
const ti = getTestId('Transactions');

export type HashType = {
  title: string;
  url: string;
  id: string;
  testId?: string;
};

export const Hash: CustomFC<HashType> = ({ title, url, id, testId }) => {
  return (
    <span className={cn('hash')} data-testid={ti(testId)}>
      {title}{' '}
      <a className={cn('link', ['link'])} href={url} target="_blank" rel="noopener noreferrer">
        {trimStringMiddle(id, 16)}
      </a>
    </span>
  );
};

export default Hash;
